/**
 * Anecdotes API
 * Anecdotes API's
 *
 * OpenAPI spec version: 0.0.3
 * Contact: apiteam@anecdotes.ai
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface ServiceField {
  /**
   * The description for this a specific field
   */
  description?: string;
  /**
   * The display name for a specific field
   */
  display_name?: string;
  /**
   * The actual field property name to be securly saved for the customer
   */
  field_name?: string;
  /**
   * Whether this field is mandatory or not
   */
  mandatory_requirement?: boolean;
  /**
   * Maximum length for this field
   */
  max_len?: number;
  /**
   * The type of input this field accepts
   */
  param_type?: ParamTypeEnum;
  /**
   * The regex pattern to validate this input against
   */
  regex_validator?: string;
  /**
   * The value of the field (for pre generated fields)
   */
  field_value?: string;
  multiple_field_values?: string[];

  json_file_format?: boolean;
  second_phase_field?: boolean;
}

export type ParamTypeEnum =
  | 'PASSWORD'
  | 'TEXT'
  | 'LONGTEXT'
  | 'EMAIL'
  | 'NUMBER'
  | 'CHECKBOX'
  | 'URL'
  | 'FILE'
  | 'CHECKBOX_PRODUCT'
  | 'PRE_GENERATED_UUID'
  | 'DROPDOWN'
  | 'MULTIDROPDOWN'
  | 'SPLITTEDUSERSEMAILS';
export const ParamTypeEnum = {
  PASSWORD: 'PASSWORD' as ParamTypeEnum,
  TEXT: 'TEXT' as ParamTypeEnum,
  LONGTEXT: 'LONGTEXT' as ParamTypeEnum,
  EMAIL: 'EMAIL' as ParamTypeEnum,
  NUMBER: 'NUMBER' as ParamTypeEnum,
  CHECKBOX: 'CHECKBOX' as ParamTypeEnum,
  URL: 'URL' as ParamTypeEnum,
  FILE: 'FILE' as ParamTypeEnum,
  CHECKBOXPRODUCT: 'CHECKBOX_PRODUCT' as ParamTypeEnum,
  PREGENERATEDUUID: 'PRE_GENERATED_UUID' as ParamTypeEnum,
  DROPDOWN: 'DROPDOWN' as ParamTypeEnum,
  MULTIDROPDOWN: 'MULTIDROPDOWN' as ParamTypeEnum,
  SPLITTEDUSERSEMAILS: 'SPLITTEDUSERSEMAILS' as ParamTypeEnum,
};
